// custom output filter
finderApp.filter('truncate', function () {
    return function (text, length, end) {
        if (typeof text != "string") {
            return text;
        }
        if (isNaN(length)) {
            length = 10;
        }
        if (end === undefined) {
            end = '…';
        }
        if (text.length <= length || text.length - end.length <= length) {
            return text;
        }
        return String(text).substring(0, length - end.length) + end;
    };
});